/**
 * CalendlyButton — visible uniquement aux utilisateurs marqués QUEBEC.
 * Pointe vers l'URL Calendly globale (configurée par le super_admin).
 */
import React from 'react';
import { Button } from './ui/button';
import { CalendarPlus } from 'lucide-react';

const CalendlyButton = ({ access }) => {
  if (!access || access.user_type !== 'QUEBEC' || !access.calendly_url) return null;
  return (
    <a
      href={access.calendly_url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="calendly-quebec-btn"
    >
      <Button className="bg-purple-600 hover:bg-purple-700 text-white font-bold shadow-lg shadow-purple-500/30">
        <CalendarPlus className="w-4 h-4 mr-2" />
        Prendre rendez-vous avec Youri
      </Button>
    </a>
  );
};

export default CalendlyButton;
